import { FC } from 'react';

import { RequiredRule } from 'devextreme-react/cjs/form';

import { AppFieldBox } from 'components/appComponents';
import { TextBox, Validator } from 'devextreme-react';

import { TrailerCreate, TrailerEdit } from '../Trailer.entity';

type Props = {
  form: TrailerCreate | TrailerEdit;
  onChange: (name: 'number', value: string) => void;
};

export const TrailerForm: FC<Props> = ({ form, onChange }) => {
  return (
    <div>
      <AppFieldBox label="Номер" labelTop>
        <TextBox
          stylingMode="underlined"
          placeholder="Введите номер"
          mode="text"
          value={form.number}
          onValueChange={(e: any) => onChange('number', e)}
          mask="LL 0000 099"
        >
          <Validator>
            <RequiredRule message="Заполните поле Номер" />
          </Validator>
        </TextBox>
      </AppFieldBox>
    </div>
  );
};

export default TrailerForm;
